(function () {
  'use strict';

  function init(dialog) {
    if (!dialog || dialog.dataset.ready === 'true') return;
    dialog.dataset.ready = 'true';

    var copyBtn = dialog.querySelector('[data-coupon-copy]');
    var code = dialog.dataset.couponCode || '';

    if (copyBtn && code) {
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(code).then(function () {
          var original = copyBtn.textContent;
          copyBtn.textContent = copyBtn.dataset.copiedLabel || 'Copied!';
          copyBtn.classList.add('is-copied');
          setTimeout(function () {
            copyBtn.textContent = original;
            copyBtn.classList.remove('is-copied');
          }, 2000);
        });
      });
    }

    var closeBtn = dialog.querySelector('[data-coupon-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { close(dialog); });
    }

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close(dialog);
    });

    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function close(dialog) {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function boot(scope) {
    var root = scope || document;
    var dialogs = root.querySelectorAll('[data-comu-coupon-modal]');
    for (var i = 0; i < dialogs.length; i++) init(dialogs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
